<template>
	<ul class="xs-12 p4">
		<li class="fs3 c1 lh150 c1" v-for="(item, i) in passwordRules" :key="i">
			{{ item }}
		</li>
	</ul>
</template>

<script>
export default {
	name: "crm-password-rules",

	props: {
		passwordRules: {
			type: Array,
			default: () => []
		}
	}
}
</script>
